import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  mapProjectTenderDetails,
  TenderListInterface,
} from "../Types/Tender/projectTenderDetailsInterface";
import {
  getProjectTenderDetails,
  getProjectTenderSowTemplate,
  getSowPriliminary,
  getSowSection,
  tenderlistCompareFromGivenList,
} from "../../Api/tenderApi";
import {
  mapPriliminarys,
  mapSowSections,
  mapTenderSows,
  Priliminary,
  SectionAndPriliminaryType,
  SowSection,
} from "../Types/Tender/tenderSow";
import { mapTenderComparisons } from "../Types/Tender/TenderCompareInterface";

export const getProjectTenderDetailList = createAsyncThunk(
  "getProjectTenderDetailList",
  async (projectId: number, { rejectWithValue }) => {
    try {
      const tenderDetails = await getProjectTenderDetails(projectId);

      if (tenderDetails.status) {
        return mapProjectTenderDetails(tenderDetails.body["data"]);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(tenderDetails.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all tenderDetails");
    }
  }
);

export const getProjectTenderSowTemplateList = createAsyncThunk(
  "getProjectTenderSowTemplateList",
  async (_, { rejectWithValue }) => {
    try {
      const tenderSows = await getProjectTenderSowTemplate();
      if (tenderSows.status) {
        return mapTenderSows(tenderSows.body);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(tenderSows.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all tenderSows");
    }
  }
);

export const getSowSectionAndPriliminary = createAsyncThunk(
  "getSowSectionAndPriliminary",
  async (project_tender_part_id: number, { rejectWithValue }) => {
    try {
      const [responseSection, responsePriliminary] = await Promise.all([
        getSowSection(project_tender_part_id),

        getSowPriliminary(project_tender_part_id),
      ]);

      if (responseSection.status && responsePriliminary.status) {
        const section: SowSection[] = mapSowSections(responseSection.body.data);
        const priliminary: Priliminary[] = mapPriliminarys(
          responsePriliminary.body.data
        );

        const sectionAndPriliminaryType: SectionAndPriliminaryType = {
          sowSection: section,
          priliminary: priliminary,
        };

        return sectionAndPriliminaryType;
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(responseSection.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch sow section and priliminary");
    }
  }
);

export const getSowSectionData = createAsyncThunk(
  "getSowSectionData",
  async (project_tender_part_id: number, { rejectWithValue }) => {
    try {
      const tenderSows = await getSowSection(project_tender_part_id);

      if (tenderSows.status) {
        const section: SowSection[] = mapSowSections(tenderSows.body.data);
        return section;
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(tenderSows.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch sow section");
    }
  }
);

export const getSowPriliminaryData = createAsyncThunk(
  "getSowPriliminaryData",
  async (project_tender_part_id: number, { rejectWithValue }) => {
    try {
      const responsePriliminary = await getSowPriliminary(
        project_tender_part_id
      );

      if (responsePriliminary.status) {
        const priliminary: Priliminary[] = mapPriliminarys(
          responsePriliminary.body.data
        );

        return priliminary;
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(responsePriliminary.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch sow priliminary");
    }
  }
);

//  get compare details from given tender list
export const getComapareFromTenderList = createAsyncThunk(
  "getComapareFromTenderList",
  async (data: any, { rejectWithValue }) => {
    try {
      // api
      const response = await tenderlistCompareFromGivenList(
        data.id as number,
        data.list as TenderListInterface[]
      );

      if (response.status) {
        return mapTenderComparisons(response.body);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all projet details");
    }
  }
);
